// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__URQJE","largestCol":"styles_largestCol__1ernO","smallestCol":"styles_smallestCol__3uqyV"};